import styled from "styled-components";
import FooterLogo from "assets/images/img_m_footer_logo.png";
import { useModalState } from "hooks";
import { PrivacySheet } from "components/voc";

const AppFooterWrapper = styled.div`
  footer {
    border-top: 1px solid #dadada;
    background-color: #fff;
    padding: 2rem 3.2rem 3rem;
  }
  footer.footer_sub {
    padding: 2rem 3rem 3rem;
  }
  footer.footer_sub .footer_inner {
    flex-flow: row nowrap;
  }
  footer.footer_sub .footer_info {
    margin-top: 1.8rem;
    font-size: 1rem;
    text-align: right;
  }
  footer .footer_inner {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-flow: row wrap;
  }
  footer .footer_logo {
    flex-shrink: 0;
    width: 6rem;
    height: 2.8rem;
    background: url(${FooterLogo}) no-repeat 0 0;
    background-size: 100% auto;
  }
  footer .footer_util {
    position: relative;
    top: 0.5rem;
    display: flex;
  }
  footer .footer_util .link {
    margin-left: 1.8rem;
    color: #454557;
    font-size: 1.2rem;
    font-family: "Pretendard";
    line-height: 1.8rem;
  }
  footer .footer_info {
    width: 100%;
    margin-top: 2rem;
    font-size: 1.1rem;
    color: #c9c9c9;
    font-family: "Pretendard";
    line-height: 1.7rem;
    text-align: center;
  }
  footer .footer_info .policy {
    color: #000000;
  }
`;

const AppFooter = () => {
  const sheetState = useModalState();
  return (
    <>
      <AppFooterWrapper>
        <footer className="footer_sub">
          <div className="footer_inner">
            <h2 className="footer_logo">
              <i className="g_ir">SK 플래닛</i>
            </h2>
            <div className="footer_info">
              <p className="copyright">COPYRIGHT © SK PLANET. ALL RIGHTS RESERVED</p>
              <p className="policy" onClick={sheetState.show}>
                개인정보 처리방침
              </p>
            </div>
          </div>
        </footer>
      </AppFooterWrapper>
      <PrivacySheet show={sheetState.showState} onClose={sheetState.show} />
    </>
  );
};

export default AppFooter;
